import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Cookies from 'js-cookie';

export default function PrivateRoute(props) {

    return (
        <>
            {(localStorage.getItem('mhet_cnd_token')) ?
                props.children
                :
                <Navigate to={`/${localStorage.getItem('mhet_cnd_project') ? localStorage.getItem('mhet_cnd_project') : "mhcet"}/`} />
            }
        </>
    )
};